import { Link } from "react-router-dom";

export default function ProductCard({ product }) {
  const minPrice = Math.min(...product.variants.map((v) => v.price));
  return (
    <Link
      to={`/product/${product.slug}`}
      className="card-kv block group"
      data-testid={`product-card-${product.slug}`}
    >
      <div className="product-img-box mb-5">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          decoding="async"
          width="600"
          height="600"
        />
      </div>
      <div className="overline mb-2">{product.strain.replace("-", " ")} Borneo</div>
      <h3 className="font-serif text-2xl tracking-tight mb-2 group-hover:text-[#C8A97E] transition-colors">
        {product.name}
      </h3>
      <p className="text-sm text-[#A8A5A1] mb-5 line-clamp-2">{product.short_desc}</p>
      <div className="flex items-center justify-between">
        <span className="text-[#F4F1ED]">
          <span className="text-xs text-[#75726D]">from </span>
          <span className="font-medium">${minPrice.toFixed(2)}</span>
        </span>
        <span className="text-xs text-[#C8A97E] tracking-widest uppercase">Shop →</span>
      </div>
    </Link>
  );
}
